var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.loaded)?_c('div',[_c('AppSelect',{attrs:{"jobs":_vm.jobData},on:{"changejob":function($event){_vm.selJob = $event}}}),_vm._v(" "),_c('AppGraph',{attrs:{"jobs":_vm.jobData,"selection":_vm.selJob}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eba34e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 876
// module chunks = 0